export default "__VITE_ASSET__e80a44ab__"